<template>
  <select
    class="select"
    :class="[
      variantClasses,
      sizeClasses,
      {
        'select-error': error,
        'select-disabled': disabled
      }
    ]"
    :disabled="disabled"
    :value="modelValue"
    v-bind="$attrs"
    @change="handleChange"
    @blur="handleBlur"
    @focus="handleFocus"
  >
    <option v-if="placeholder" value="" disabled>
      {{ placeholder }}
    </option>
    <slot />
  </select>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'default',
    validator: val => ['default', 'filled', 'outline'].includes(val)
  },
  size: {
    type: String,
    default: 'md',
    validator: val => ['sm', 'md', 'lg'].includes(val)
  },
  disabled: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'blur', 'focus'])

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'filled':
      return 'bg-surface-container-low border-outline-variant text-on-surface focus:border-secondary focus:bg-surface-container-lowest'
    case 'outline':
      return 'bg-transparent border-outline text-on-surface focus:border-secondary focus:bg-surface-container-low'
    case 'default':
    default:
      return 'bg-surface-container-low border-outline-variant text-on-surface focus:border-secondary hover:border-outline'
  }
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'select-sm'
    case 'lg':
      return 'select-lg'
    case 'md':
    default:
      return ''
  }
})

const handleChange = event => {
  emit('update:modelValue', event.target.value)
}

const handleBlur = event => {
  emit('blur', event)
}

const handleFocus = event => {
  emit('focus', event)
}
</script>
